import gql from 'graphql-tag';

export const integrationGoogleDriveFragment = gql`
  fragment integrationGoogleDriveFragment on IntegrationGoogleDrive {
    dokkioClass
    id
    accountID
    syncFolderRemoteID
    syncFolderSpecialFolderType
    syncFolderPath
  }
`;
export default integrationGoogleDriveFragment;
